module.exports = {"invoices":"Invoices"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/invoice.json
// module id = P78e
// module chunks = 9